import ProductSelection from '@/containers/ProductSelection';
import AdditionalProductConfirmation from '@/containers/AdditionalProductConfirmation';

import { FLOW_STEP_PATHS, APP_PATHS } from '@/constants';
import {
  getDefaultRoleConstraints,
  hasAtLeastOneStakeholder,
  hasBankAccounts,
  hasMaxUBOsWithMultipleRoles,
  hasUltimateBeneficialOwner,
  isNotPayoutsEnabled,
} from '../selectors';

const ADDITIONAL_PRODUCTS_FLOW = [
  {
    id: 'product-selection',
    path: FLOW_STEP_PATHS.PRODUCT_SELECTION_PATH,
    Container: ProductSelection,
    back: APP_PATHS.WHATS_NEXT_PATH,
    next: FLOW_STEP_PATHS.ADDITIONAL_PRODUCT_CONFIRMATION_PATH,
  },
  {
    id: 'additional-product-confirmation',
    path: FLOW_STEP_PATHS.ADDITIONAL_PRODUCT_CONFIRMATION_PATH,
    Container: AdditionalProductConfirmation,
    back: FLOW_STEP_PATHS.PRODUCT_SELECTION_PATH,
    next: APP_PATHS.WHATS_NEXT_PATH,
  },
];

export const enablePayoutsConfig = () => {
  return {
    stepNotFoundPath: APP_PATHS.WHATS_NEXT_PATH,
    selectors: {
      defaultRoleConstraints: getDefaultRoleConstraints,
      hasAtLeastOneStakeholder,
      hasBankAccounts,
      hasMaxUBOsWithMultipleRoles,
      hasUltimateBeneficialOwner,
      isNotPayoutsEnabled,
    },
    neededCaps: {},
    steps: ADDITIONAL_PRODUCTS_FLOW,
  };
};
